import { Inject } from '@odinjs/odin';
import { InputAPI, ModalService } from '@philips-internal/oswald-ui-components';
import Controller, { OnCancel, OnSubmit } from '@philips-internal/oswald-ui-core/lib/client';
import { HttpService, HttpStatus } from '@philips-internal/oswald-ui-core/lib/services';
import { applicationContext } from '@philips-internal/oswald-ui-foundation';
import { FragmentNames, JustifyModalAliases } from '../../codegen';
import { showToastNotificationSuccess } from '../../utils/toast-notification-utils';
import BaseController from '../BaseController';

@Controller({ component: JustifyModalAliases.LAYOUT_JUSTIFY, fragment: FragmentNames.JUSTIFY_MODAL })
export default class JustifyModalController extends BaseController {

  @Inject(JustifyModalAliases.INPUT_JUSTIFY )
    justifyAPI!: InputAPI;
  justifyModalID = 'justify-modal';

  @OnSubmit(JustifyModalAliases.FORM_JUSTIFY)
  OnSubmitJustify(): void {
    const endpoint = this.context.get('endpoint') as string;

    HttpService.put(endpoint, { justify: this.justifyAPI.getValue(), sequence: this.context.get('sequence') })
      .then(response => {
        if(response.status === HttpStatus.OK) {
          showToastNotificationSuccess('patient.my-chart.inactivated-success');
        }
      })
      .then(() => {
        ModalService.close(this.justifyModalID);
        applicationContext.popNavigationItem();
      });
  }

  @OnCancel(JustifyModalAliases.FORM_JUSTIFY)
  onClickCancelButton(): void {
    ModalService.close(this.justifyModalID);
  }

}